export default __webpack_public_path__ + "static/media/chart.25bf21f1.svg";